import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Small = (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34 34" }, { children: _jsx("path", { fill: "currentColor", d: "M29.36 0H4.64A4.64 4.64 0 000 4.64v24.72A4.64 4.64 0 004.64 34h24.72A4.64 4.64 0 0034 29.36V4.64A4.64 4.64 0 0029.36 0zM1.42 4.64a3.22 3.22 0 013.22-3.22h11.65v14.87H1.42zm0 24.72V17.71h14.87v14.87H4.64a3.22 3.22 0 01-3.22-3.22zm31.16 0a3.22 3.22 0 01-3.22 3.22H17.71V17.71h14.87zM17.71 16.29V1.42h11.65a3.22 3.22 0 013.22 3.22v11.65z" }, void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
